export const REVIEW_CLASSES = [
  'danger',
  'danger',
  'warning',
  'success',
  'success',
  'success'
];

export const STATUS_TEXTS = {
  pre_transit:
    'Carrier has received information about the package, but it has not yet been scanned and picked up.',
  no_info:
    'A shipping label has been created, but the package has not yet been scanned and/or picked up by the carrier.',
  in_transit:
    'A package is travelling to its destination. You may receive multiple updates of this type as the package travels to its destination.',
  delivery_in_progress:
    'A package has reached the local area and is in the process of being delivered.',
  return_to_sender:
    'The package was not delivered and is now on its way back to the sender.',
  expired:
    'A package has no tracking information for 30 days since it was created.',
  transit_limit_exceeded:
    'The package has been in transit way longer than normal transit time allows. Please contact the carrier.',
  // eslint-disable-next-line
  customs_clearance:
    // eslint-disable-next-line
    'Your package is being processed by customs. If needed, you may be contacted for additional documentation, information or payment of duties/taxes. Please be prepared to provide requested details promptly.',
  unsuccessful_delivery:
    'Carrier attempted to deliver, but failed, and usually leaves a notice and will try to deliver again.',
  error: 'Unable to track this parcel due to technical issues. Please re-track',
  exception:
    'Customs hold or any shipping exceptions. Please contact the carrier.',
  cancelled: 'The delivery has been cancelled.',
  available_for_pickup:
    'The package is available for pickup from the carrier\'s facility.',
  delivered: 'The package has been delivered.'
};
